import React from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { BreadcrumbProps } from '../Breadcrumb';
import { IconButton } from '../Buttons/IconButton';

export interface BreadcrumbsProps {
  items: BreadcrumbProps[];
  onCopy?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  copyAriaLabel?: string;
  highlightLastItem?: boolean;
  t?: (key: string) => string;
}

export const getBreadcrumbItems = (
  items: BreadcrumbProps[],
  isSmallDevice: boolean,
  handleMoreClick: (event: React.MouseEvent<HTMLButtonElement> | null) => void,
) => {
  let result: BreadcrumbProps[] = items;
  if (items.length === 0) {
    return [];
  }
  // only show the last item on small devices
  if (isSmallDevice) {
    if (items.length > 1) {
      result = [
        {
          label: 'More',
          render: () => (
            <IconButton
              key="ellipses"
              icon={<MoreHorizIcon />}
              onClick={handleMoreClick}
              aria-label="Show more breadcrumbs"
            >
              <MoreHorizIcon />
            </IconButton>
          ),
        },
        items[items.length - 1],
      ];
    } else {
      result = [items[items.length - 1]];
    }
  } else {
    // only show the first and last two items on large devices
    if (items.length > 3) {
      result = [
        items[0],
        {
          label: 'More',
          render: () => (
            <IconButton
              key="ellipses"
              icon={<MoreHorizIcon />}
              onClick={handleMoreClick}
              aria-label="Show more breadcrumbs"
            >
              <MoreHorizIcon />
            </IconButton>
          ),
        },
        items[items.length - 2],
        items[items.length - 1],
      ];
    }
  }
  // For presentation purposes, the last breadcrumb is marked as the last one
  result[result.length - 1] = { ...result[result.length - 1], isLast: true };
  return result;
};

export const getMenuBreadcrumbs = (items: BreadcrumbProps[], isSmallDevice: boolean) => {
  if (isSmallDevice) {
    return items.slice(0, items.length - 1);
  }
  return items.slice(1, items.length - 2);
};
